<template>
  <div class="vi-modal display-location">
    <div class="vi-modal-content">
      <div class="close-modal" @click="close">
        <img src="../../assets/icon_clear.svg"/>
      </div>
      <div class="map-container">
        <GmapMap
          v-if="center"
          :center="center"
          :zoom="15"
          :options="options"
          :disableDefaultUi="false"
          :streetViewControl="false"
          style="width: 500px; height: 300px"
        >
          <GmapMarker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :icon="m.icon"
            :clickable="true"
            @click="center=m.position"
          />
        </GmapMap>
      </div>

    </div>
  </div>
</template>

<script>

  import {options} from "../../services/googleMap";

  export default {
    name: 'DisplayLocation',
    props: {
      markers: {
        type: Array,
        default: () => {
          return []
        }
      },
    },

    data() {
      return {
        options,
      }
    },

    methods: {
      close() {
        this.$emit('close')
      }
    },

    computed: {
      center() {
        if (this.markers.length === 0) return null;
        return {
          lat: this.markers[0].position.lat,
          lng: this.markers[0].position.lng,
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "DisplayLocation";
</style>
